import type { ReactNode } from 'react';

export const symbol_nest_connect: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M614.5-245.57Q670-301.15 670-380v-200q0-78.85-55.61-134.42Q558.79-770 479.89-770 401-770 345.5-714.42 290-658.85 290-580v200q0 78.85 55.61 134.43Q401.21-190 480.11-190q78.89 0 134.39-55.57ZM388-287.92q-38-37.91-38-92.08v-200q0-54.17 37.88-92.08 37.88-37.92 92-37.92T572-672.08q38 37.91 38 92.08v200q0 54.17-37.88 92.08-37.88 37.92-92 37.92T388-287.92Zm113.5-310.76q8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5 12.82 0 21.32-8.68ZM180-40q-24.75 0-42.37-17.63Q120-75.25 120-100v-760q0-24.75 17.63-42.38Q155.25-920 180-920h600q24.75 0 42.38 17.62Q840-884.75 840-860v760q0 24.75-17.62 42.37Q804.75-40 780-40H180Zm0-60h600v-760H180v760Zm0 0v-760 760Z"
		/>
	</svg>
);
